//PrimeReact
import { Button } from "primereact/button"
import { TabPanel, TabView } from "primereact/tabview"

//Styles
import kioskStyles from "../../../../styles/kiosk/KioskAdmin.module.css"
import myStyles from "../../../../styles/kiosk/KioskAdminFormWizard.module.css"

//Wizard componnets
import WizardPageActionsEmail from "./WizardPageActionsEmail"
import WizardPageActionsSignalR from "./WizardPageActionsSignalR"

export default function WizardPageActions({
  staffList,
  onCancel,
  onBack,
  isSubmitting,
}) {
  return (
    <div className={myStyles.wizardPage}>
      <div className={myStyles.actionsLayout}>
        <div
          className={`${myStyles.actionsLayoutTitle} ${myStyles.actionTitle}`}
        >
          Post Submit Actions
        </div>
        <div className={myStyles.actionsLayoutDescription}>
          Add optional actions that will be performed after the form has been
          submitted
        </div>
        <div
          className={`${myStyles.actionsLayoutSettings} ${kioskStyles.tabView}`}
        >
          <TabView>
            <TabPanel header={"Email"}>
              <WizardPageActionsEmail
                staffList={staffList}
                disabled={isSubmitting}
              />
            </TabPanel>
            <TabPanel header={"Notifications"} disabled={isSubmitting}>
              <WizardPageActionsSignalR disabled={isSubmitting} />
            </TabPanel>
          </TabView>
        </div>
        <div
          className={`${myStyles.actionsLayoutActions} ${myStyles.buttonGroup}`}
        >
          <Button
            label="Back"
            type="button"
            onClick={() => {
              onBack()
            }}
            className={`${kioskStyles.button}`}
            disabled={isSubmitting}
          />
          <Button
            label="Submit"
            type="submit"
            className={`${kioskStyles.button} ${kioskStyles.primaryButton}`}
            disabled={isSubmitting}
            iconPos="left"
            icon={isSubmitting && "pi pi-spin pi-spinner"}
          />
        </div>
      </div>
    </div>
  )
}
